import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { allowedMessageProps } from '../../lists/SystemMessages';
import { allowedSelectOptionTypes, allowedReactSelectValueTypes } from './_allowedPropTypes';

const InputFieldSelectAsync = ({
  inputAttributes,
  translate,
  message,
  label,
  description,
  options,
  isMulti = false,
  loadingMessage,
  noOptionsMessage,
  customChangeHandler
}) => {
  const { value: passedValue } = inputAttributes;

  if (isMulti !== Array.isArray(passedValue)) {
    throw new Error(
      `ERROR: Select expects string-typed value or array-typed value and isMulti param to be "true",
      but got ${typeof (passedValue)}-typed value and isMulti:${isMulti.toString()}.`
    );
  }

  const finalInputAttributes = {
    ...inputAttributes,
    className: 'react-select-wrap',
    value: passedValue,
    'aria-invalid': !!message
  };

  if (customChangeHandler) {
    finalInputAttributes.onChange = function (newValue) {
      if (customChangeHandler) {
        customChangeHandler({ value: newValue });
      }

      else {
        inputAttributes.onChange(newValue);
      }
    };
  }

  const reactSelectProps = {
    options,
    isMulti,
    classNamePrefix: 'react-select',
    loadingMessage: userInput => (loadingMessage
      ? loadingMessage(userInput)
      : translate('input-selectAsync-loading-text')),
    noOptionsMessage: userInput => (noOptionsMessage
      ? noOptionsMessage(userInput)
      : translate('input-selectAsync-noOptions-text'))
  };

  if (!label) {
    finalInputAttributes.title = description;
  }

  const result = <AsyncSelect {...finalInputAttributes} {...reactSelectProps} />;

  return (<div className='react-select-outer-div' style={{ height: '40px' }}>{result}</div>);
};

InputFieldSelectAsync.propTypes = {
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    value: PropTypes.oneOfType(allowedReactSelectValueTypes).isRequired
  }).isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ]),
  description: PropTypes.string.isRequired,
  message: PropTypes.shape(allowedMessageProps),
  setFieldValue: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType(allowedSelectOptionTypes)
  ).isRequired,
  loadingMessage: PropTypes.func,
  noOptionsMessage: PropTypes.func,
  customChangeHandler: PropTypes.func
};

export default withLocalization(InputFieldSelectAsync, 'elements/customInput');